/**
 * Утилита, проверяет есть ли у родителей элемента хотябы один из указанных классов
 * можно указать глубину, по умолчанию - 2
 *
 * @param {Element} target
 * @param {string[]} classList
 * @param {number} [deep=2] - глубина поиска
 */
const parentsDeepHasClassList = (target, classList = [], deep = 2) => {
    if (!(target instanceof Element)) return;

    const { parentElement } = target;
    const isHas = classList.some((className) => parentElement.classList.contains(className));

    if (deep-1 > 0 && !isHas) {
        deep--;
        return parentsDeepHasClassList(parentElement, classList, deep);
    }

    return isHas;
};

export { parentsDeepHasClassList };
